export class DropMiddleRequestModel {

  // General
  date: string;  // "2021-08-25"
  time: string; // "10:32 AM"
  clientId: number;
  engagementId: number;
  engTeamClientId: number;
  engTeamClientDocId: number;
  firmId: number;
  isnewcopy? : number;

  // Source
  sourceFileExtension: string; // "pdf"
  sourceFileExtensionPath: string;  // "/assets/images/extension/pdf.svg\n"
  sourceFilename: string; // "ticket.pdf"
  sourceFileNameChange: string; // "ticket.pdf"
  sourceFileOriginalFileName: string; // "ticket.pdf"
  sourceFileDirectory: string; // "Engagements/1997_Firm/2020_Partner/PartnerDocs/2061_Client/Test
  sourceFileNameWithoutExtension: string; // "ticket"
  sourceFilePath: string; // "Engagements/1997_Firm/2020_Partner/PartnerDocs/2061_Client/Test/ticket.pdf"
  userFullName: string; // "Amar PartnerTEST"
  isRead: number; // 0
  sourceFileMsSdkId: string; // "a72cab05-86ad-495f-aa89-680ac38cadf9"
  sourcePartnerFolderFileId: number; // 463
  sourcePartnerFolderId: number; // 72

  // Destination
  destinationRefPkId: number;
  destinationFinSubGroupId: number;
  destinationModule: number; // for destination file
  destinationSubModuleId: number; // keep a copy of the subModuleId from the source element in the drag and drop
  destinationLeadSheetId: number;
  destinationDirectory: string;
  destinationLeadSheetName: string;
  destinationFinSubGroupName: string;
}

